<template>
  <div class="page-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">
          <span v-if="planInfo">{{ planInfo.plan_name }}</span>
          <span v-else>开班详情</span>
        </p>
        <div class="nav-right" slot="right"></div>
      </yioks-page-nav>
      <div class="page-loading" v-if="pageLoading">
        <yioks-loading></yioks-loading>
      </div>
      
      <template v-if="!pageLoading">
        <div class="info-wrap">
          <div class="info-box">
            <div class="show-wrap">
              <img :src="levelLogo" class="picture" />
            </div>
            <div class="detail-info">
              <p class="info-item">计划开班等级：{{ planInfo.plan_level }}</p>
              <p class="info-item">
                计划开班数量：{{ ClassPlanOrganNumber }}
              </p>
              <p class="info-item" v-if="planInfo.plan_type === 'month'">
                计划开班月份：{{ planInfo.plan_date }}
              </p>
              <p class="info-item" v-if="planInfo.plan_type === 'month'">
                计划开班截止日期：{{ planInfo.plan_end_date | time(false) }}
              </p>
            </div>
          </div>
        </div>
        
        <div class="deatil_main">
          <div class="scroll_wrap">
            <vue-scroll :ops="vuescrollOpt" ref="vScroll">
              <div class="scroll-content">
                <!-- 计划开班详情 -->
                <div class="itemWrap">
                  <div class="titleWrap">
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="user-friends"
                        scale="1.8"
                      ></v-icon>
                      <p>计划开班详情</p>
                    </div>
                  </div>
                  
                  <div class="contentInfo no-border">
                    <div class="search-box">
                      <div class="left">
                        <div class="search-item">
                          <el-select
                            v-model="search.org_id"
                            class=""
                            size="medium"
                            placeholder="请选择协会"
                            @change="searchChange"
                            clearable
                          >
                            <el-option :label="'全部协会'" value="">
                            </el-option>
                            <el-option v-for="(item, index) in organList" :key="index" :value="item.org_id" :label="item.org_abbreviation"></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="right"></div>
                    </div>
                    <div class="table-box">
                      <!-- div.tbale -->
                      <div class="content-box" v-if="!isShoworgList">
                        <div class="table-list">
                          <div
                            class="sign-item"
                            v-for="(items, index) in orgList"
                            :key="index"
                          >
                            <div class="org-info">
                              <div class="logo-box">
                                <img
                                  :src="items.profile_picture || User"
                                  alt=""
                                  @error="imgError(items)"
                                  class="logo"
                                />
                              </div>
                              <div class="name-box">
                                {{ items.org_abbreviation }}
                              </div>
                            </div>
                            <div class="phase-info">
                              <div class="btn-list">
                                <div class="time-btn" @click="handleCheckSignInfo(items)" v-if="planInfo.plan_type === 'month'">
                                  计划开班数量：{{ items.plan_number }}
                                </div>
                                <div  v-else style="padding:10px 5px;">
                                  <div style="display: flex">
                                    <p>第一季度：{{ items.number_one }}</p>
                                    <p style="margin-left:20px">第二季度：{{ items.number_two }}</p>
                                    <p style="margin-left:20px">第三季度：{{ items.number_three }}</p>
                                    <p style="margin-left:20px">第四季度：{{ items.number_four }}</p>
                                  </div>
                                  <div>
                                    <p>共计：{{ items.plan_number }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <yioks-paging
                          :paging="paging"
                          @goto-page="gotoPage($event)"
                        ></yioks-paging>
                      </div>
                      <div class="empty-box" v-if="isShoworgList">
                        <yioks-empty
                          v-show="isShoworgList"
                          :h="'220px'"
                        ></yioks-empty>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </template>
    </div>
    <template v-if="isShowViewClassPlanInfo">
      <view-class-plan-info
        :isShowDialog.sync="isShowViewClassPlanInfo"
        :planId="plan_id"
        :orgId="org_id"
        :planLevel="plan_level"
      ></view-class-plan-info>
    </template>
  </div>
</template>

<script>
  import { orgList } from "@/api/system_manager/api";
  import {claassPlanSysInfo,claassPlanOrganListSys} from "@/api/class_plan/api";
  import ops from "@/assets/js/vuescrollOption";
  import levelLogo from "@/assets/images/footballAssociation.png";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  import "vue-awesome/icons/regular/address-book";
  import "vue-awesome/icons/user-friends";
  import "vue-awesome/icons/regular/clock";
  import User from "@/assets/images/person.png";
  export default {
    data() {
      return {
        User,
        ops: ops(),
        vuescrollOpt: createScrollOpt(),
        plan_id: this.$route.query.plan_id,
        planInfo: {
          plan_date: "",
          plan_end_date: "",
          plan_id: "",
          plan_level: "",
          plan_name: "",
          plan_status: "",
        },
        ClassPlanOrganNumber:0,
        pageLoading: false,
        levelLogo,
        search: {
          org_id: "",
        },
        page: 1,
        paging: {
          start: 0,
          prePage: 1, // 一页多少条数据
          total: 1, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true,
        },
        orgList: [],
        isShoworgList: false,
        org_id:"",
        plan_level:"",
        isShowViewClassPlanInfo: false,
        organList: [],
      };
    },
    
    filters: {},
    
    components: {
      "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-tips": () => import("@/components/Tips/Dialog"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "view-class-plan-info":() => import("@/components/ClassPlan/ViewClassPlanInfo"), // 查看会员协会开班计划
    },
    
    computed: {
      uuid() {
        const { uuid } = this.$route.query;
        return uuid;
      },
    },
    
    created() {
      this.getOrganList();
      this.getClaassPlanInfo();
      this.claassPlanOrganList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      // 获取page信息
      getClaassPlanInfo() {
        this.pageLoading = true;
        claassPlanSysInfo({
          plan_id:this.$route.query.plan_id
        }).then(({ data }) => {
          this.pageLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { classPlan,ClassPlanOrganNumber } = data.result;
          classPlan && (this.planInfo = classPlan);
          ClassPlanOrganNumber && (this.ClassPlanOrganNumber = ClassPlanOrganNumber);
        })
        .catch((err) => {
          this.pageLoading = false;
          console.error("err", err);
        });
      },
      
      
      searchChange() {
        this.changeQuery(true);
      },
      // 获取招标计划的投标信息
      claassPlanOrganList() {
        const { org_id } = this.search;
        const queryData = {
          plan_id: this.$route.query.plan_id,
          org_id,
          page: this.page,
        };
        console.log(queryData);
        claassPlanOrganListSys(queryData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { list, page } = data.result;
          this.$set(this.paging, "prePage", page.page_size);
          this.$set(this.paging, "total", page.total_row);
          this.$set(
            this.paging,
            "start",
            (this.page - 1) * this.paging.prePage
          );
          if (list.length) {
            this.isShoworgList = false;
            this.orgList = list;
          } else {
            this.isShoworgList = true;
            this.orgList = [];
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
      },
      
      changeQuery(flag) {
        if (flag) this.page = 0;
        this.claassPlanOrganList();
      },
      
      gotoPage(start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
        this.$refs["vs"].scrollTo({ y: 0 });
      },
      
      imgError(row) {
        let { profile_picture } = row;
        row.profile_picture = this.User;
      },
      handleCheckSignInfo(row) {
        console.log(row);
        const { org_id } = row;
        if (!org_id) return;
        this.isShowViewClassPlanInfo = true;
        this.plan_id = this.$route.query.plan_id;
        this.org_id = org_id;
        this.plan_level = this.planInfo.plan_level;
      },
      getOrganList(){
        orgList({}).then(res=>{
          const {organization}=res.data.result;
          this.organList=organization;
        }).catch(err=>{
        
        })
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  @import '~@/assets/css/mixin'
  .page-root
    zuxie-page-root()
    .main-content-wrap
      color $color_white
      font-size $font_size_medium
      line-height inherit
      .nav-wrap
        margin-bottom 20px
      .page-loading
        display block
        position relative
        width 100%
        height 650px
        background-color $block_bg_color_base
      .info-wrap
        display flex
        align-items center
        margin-bottom 10px
        padding 0 20px
        background-color $block_bg_color_base
        .info-box
          padding 20px 0
          flex 1
          display flex
          align-items flex-start
          .show-wrap
            flex none
            position relative
            z-index 10
            width 130px
            height 130px
            margin-right 15px
            cursor pointer
            .picture
              display block
              width 100%
              height 100%
            .status-flat
              left 3px
              top 8px
          .detail-info
            font-size $font_size_medium
            flex 1
            .info-item
              margin-bottom 0.35em
        .btns_wrap
          .zuxie-btn
            &+.zuxie-btn
              margin-left 10px
      .deatil_main
        display block
        width 100%
        height 450px
        background-color $block_bg_color_base
        .scroll_wrap
          display block
          width 100%
          height 100%
          padding-top 20px
          overflow hidden
          .scroll-content
            display block
            padding 0 19px
            .itemWrap
              margin-bottom 30px
              .loading_wrap
                display block
                position relative
                width 100%
                height 100px
              .titleWrap
                margin-bottom 20px
                display flex
                justify-content space-between
                font-size 20px
                user-select none
                .empty_wrap
                  height 100px
                  width 100%
                .title
                  display flex
                  align-items flex-end
                  .logo
                    margin-right 10px
                  p
                    line-height 20px
                    span
                      margin 0 0 0 10px
                      font-size $font_size_medium
              .contentInfo
                font-size $font_size_big
                border 1px solid $color_white
                .row
                  display block
                  padding 10px
                  border-bottom 1px solid $color_white
                  .col
                    display flex
                    .intro
                      min-width 55px
                  &:last-child
                    border-bottom none
                  .name, .phone
                    width 30%
                  .email
                    width 40%
                &.connect
                  .row
                    padding 10px
                    display flex
                    align-items center
                &.time
                  .row
                    padding 10px
                    display flex
                    align-items center
                    .col
                      flex 1
                      display flex
                      align-items center
                      justify-content center
                      &.label
                        flex none
                        width 30%
                      &.content
                        flex none
                        width 70%
                        justify-content flex-start
  .no-border
    box-sizing border-box !important
    border none !important
  .search-item
    margin-right 10px
  .table-list
    padding 20px 0px
    box-sizing border-box
    margin-bottom 10px
  .sign-item
    width 100%
    display flex
    border 1px solid #fff
    box-sizing border-box
    justify-content flex-start
    .org-info
      padding 20px 10px
      width 200px
      display flex
      justify-content space-around
      align-items center
      border-right 1px solid #fff
      .logo-box
        width 60px
        height 60px
        border-radius 50%
        overflow hidden
    .line-name
      width 30px
      text-align center
      border-right 1px solid #fff
      font-size 16px
      display flex
      flex-direction column
      justify-content space-around
    .phase-info
      flex 1
      padding 10px 15px
      display flex
      flex-wrap wrap
      .btn-list
        .time-btn
          color $color_suc
          padding 25px 5px
          cursor pointer
        &:not(:last-child)
          .time-btn
            border-right 1px solid #fff
  
  .search-box
    display: flex
    justify-content space-between
    .left
      display: flex
      justify-content: flex-start
      .search-item
        margin 0px
        &:not(:first-child)
          margin-left 20px
  
  .over
    over_hide()
</style>
